/** 员工名册头像格（纯函数，无 DOM 依赖）。
 *
 * 主人 2026-10-14 令：「控制台上员工列表要显示头像和昵称」。
 * 头像来自 `bff_platform_profiles.extra_json["avatar_url"]`（员工扫码时授权写入，
 * 见 `store/merchant_auth_qr._apply_staff_profile`），由 `/merchant/team/members` 随行返回。
 *
 * 三条口径：
 *   ① 头像是**装饰**不是身份依据 —— 没有就出首字占位，绝不因此少渲染点什么；
 *   ② 本模块只吐 HTML 字符串，**不碰 DOM、不绑事件**：名册是整段 `innerHTML` 重建的
 *      （`team.js renderMembers`），逐行绑事件会漏；
 *   ③ 所有插值走 `escHtml`（昵称是**员工自己填的**，可含 `<` `"`）。
 */
import { escHtml } from "./hints.js";

/** 取第一个「字符」当占位字。用展开运算符而不是 `[0]`：
 * 昵称首字可能是代理对（emoji / 生僻字），`[0]` 会截出半个码元显示成乱码。 */
function firstChar(name) {
  const s = String(name || "").trim();
  if (!s) return "员";
  const ch = [...s][0] || "员";
  return ch.toUpperCase();
}

/** 名册行左侧那个圆。有头像出 `<img>`，没有出首字占位。 */
export function memberAvatarHtml(m) {
  const url = String((m && m.avatar_url) || "").trim();
  const name = String((m && (m.nickname || m.display_name)) || "").trim();
  if (url) {
    return (
      `<img class="mc-team-avatar" src="${escHtml(url)}"` +
      ` alt="${escHtml(name || "员工头像")}" loading="lazy" />`
    );
  }
  return (
    `<span class="mc-team-avatar mc-team-avatar-ph" aria-hidden="true">` +
    `${escHtml(firstChar(name))}</span>`
  );
}
